<template>
  <RuesBoxSize :size="props.item?.width">
    <SharedCard>
      <template #img>
        <DelayedComponent :delay="3000">
          <img
            loading="lazy"
            src="https://img.travanto.de/travanto/img/elegantes_fahrrad_in_der_natur.webp"
            alt="Mietrad.de"
            height="auto"
            width="auto"
            :class="[ 'aspect-video object-cover object-center w-full fade-in' ]"
          >
          <template #preview>
            <div :class="[ 'aspect-video object-cover object-center w-full' ]" />
          </template>
        </DelayedComponent>
      </template>
      <template #text>
        <div class="grid gap-3 h-full">
          <div class="text-lg font-semibold">
            {{ t('headline', { region: portal.location ?? '' }) }}
          </div>
          <div class="text-sm">
            {{ t('text') }}
          </div>
          <div class="flex gap-4 w-full mt-4 text-base self-end">
            <UiMaskedLink
              :href="props.item?.url || ''"
              :new-tab="true"
              class="w-full"
            >
              <UiButton color="primary-high-contrast" class="w-full">
                {{ t('button') }}
              </UiButton>
            </UiMaskedLink>
          </div>
        </div>
      </template>
    </SharedCard>
  </RuesBoxSize>
</template>

<script setup>
const t = useTranslations('RuesCardMietrad').translate
const { links: portal } = usePortalData()
const props = defineProps({
  item: {
    type: Object,
    default: null
  }
})
</script>
